import AxiosWrapper from "~/assets/javascript/AxiosWrapper"
import { updateField, getField } from 'vuex-map-fields'
import { translate } from '~/assets/javascript/localization/Localization'
import ModalHelper from "~/components/ModalHelper"

const getDefaultState = () => ({
  showModal: false,
  licenceZoneId: null,
  allZones: null,
  licenceId: null,
  zonedLicenses: [],
  nonZonedLicences: [],
  isUserSuperuser: null,
  permissions: null,
  items_per_page: 75,
  page: 1,
  total_pages: null,
  total: null,
  loadingMessage: translate('loading'),
  sortOrder: [{
    field: '__component:device-qr-code',
    sortField: 'grouping',
    direction: 'asc'
  }]
})

export const state = getDefaultState

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setShowModal(state, value) {
    state.showModal = value
  },
  setLicenceId(state, id) {
    state.licenceId = id
  },
  setInitData(state, data) {
    state.allZones = data.all_zones;
    state.licenceZoneId = data.licence_zone_id;
    if (state.licenceZoneId == null) {
      state.licenceZoneId = (state.allZones[0]).id
    }
  },
  setUnassignedLicencesData(state, data) {
    state.nonZonedLicences = data.non_zoned_licenses;
    state.isUserSuperuser = data.is_user_superuser;
    state.zonedLicenses = data.zoned_licences;
    state.total_pages = data.total_pages;
    state.items_per_page = data.items_per_page;
    state.page = data.page;
    state.total = data.total;
    if (state.zonedLicenses.length == 0) state.loadingMessage = translate('error_loading')
  },
  updateField
}

export const getters = {
  getField
}

export const actions = {
  async openModal({ commit }, id) {
    commit('setLicenceId', id)
    AxiosWrapper.get(`/data_api/devices/assign_zone?licence_id=${id}`).then(({ data }) => {
      commit('setInitData', data)
      ModalHelper.addShowParamToUrl('show_assign_zone', id, 'Assign Zone')
      commit("setShowModal", true)
    })
  },
  async closeModal({ commit }) {
    ModalHelper.removeShowParamFromUrl('show_assign_zone', 'Unassigned Licences')
    commit('setLicenceId', null)
    commit("setShowModal", false)
  },
  // async submitButtonPressed({ state }, router) {
  //   ModalHelper.removeShowParamFromUrl('show_assign_zone', 'Unassigned Licences')
  //   await AxiosWrapper.patch(`/data_api/devices/update_licence?licence_id=${state.licenceId}`, { zone_id: state.licenceZoneId }).then(router.go())
  // },

  async submitButtonPressed({ state, dispatch, commit }) {
    ModalHelper.removeShowParamFromUrl('show_assign_zone', 'Unassigned Licences');
    try {
      await AxiosWrapper.patch(
        `/data_api/devices/update_licence?licence_id=${state.licenceId}`,
        { zone_id: state.licenceZoneId }
      );
      commit("setShowModal", false); // close modal
      await dispatch("initUnassignedLicences"); // refresh updated list
    } catch (error) {
      this.$toast.error(translate("there_was_a_problem"), { duration: 1000 })
    }
  },
  async initUnassignedLicences({ dispatch, commit, state }) {
    let params = {
      page: state.page,
      items_per_page: state.items_per_page,
    }
    AxiosWrapper.get(`/data_api/devices/unassigned?items_per_page=${params.items_per_page}&page=${params.page}`).then(({ data }) => {
      commit('setUnassignedLicencesData', data)
      let params = AxiosWrapper.getSearchParams()
      if (Object.keys(params).includes('show_assign_zone')) dispatch('openModal', params['show_assign_zone'])
    })
  },
  async setPageAndThenGetPage({ dispatch, commit }, page) {
    commit('updateField', { path: "page", value: page });
    dispatch('initUnassignedLicences');
  },
  async changeNumberOfItemsPerPage({ commit, dispatch }, itemsPerPage) {
    commit('updateField', {
      path: 'items_per_page',
      value: itemsPerPage
    });
    dispatch('initUnassignedLicences');
  },
}